module.exports = __webpack_public_path__ + "static/media/add-domain.15fc6269.svg";